<template>
  <div class="">
    <salesmen-edit> </salesmen-edit>
  </div>
</template>

<script>
import SalesmenEdit from "@/components/profile/brokers/salesmen/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    SalesmenEdit,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Produttori",
        path: "module.PROF.PRCO",
        tab: "#Salesmen",
        level: 3,
      });
      bcs.push({
        text: "Modifica Produttore",
        path: "brokers.edit",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Produttori",
        path: "module.PROF.PRCO",
        tab: "#Salesmen",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica Produttore",
        path: "brokers.edit",
        level: 4,
      });
    }
  },
};
</script>
